module.exports = __webpack_public_path__ + "static/media/company.8c3df460.svg";